// extracted by mini-css-extract-plugin
export default {"section":"text-block-module--section--87a14","preamble":"text-block-module--preamble--dcfed"};